export class DiagramValidationErrorModel {
    reason;

    type;

    aditional;

    constructor(data) {
        this.type = data.type;
        this.reason = data.reason;
        this.aditional = data.aditional;
    }
}
